<template>
  <div class="recruit">
	<div class="zaopinBox">
		<div class="zaopinBoxFor" v-for="(item,index) in recruitList.recruitment_type" :key="index" @click="goDetail(item)">
			<div class="zaopinBoxImg">
				<img :src="item.cover" />
			</div>
			<div class="zaopinBoxBtm">
				<div class="zaopinBoxBtmName">{{item.title}}</div>
				<div class="zaopinBoxBtmMore">{{$t('i18n_321')}}</div>
				<div class="zaopinBoxBtmJt">
					<i class="el-icon-arrow-right"></i>
				</div>
			</div>
		</div>
	</div>
	<!-- 健康事业 -->
	<div class="jksy" v-if="recruitList.select_ah">
		<div class="jksyTil">{{recruitList.select_ah.title}}</div>
		<div class="jksyNr">
			<div class="jksyNrFor" v-for="(item,index) in recruitList.select_ah.tableData" :key="index">
				<div class="jksyNrForImg">
					<img :src="item.cover" />
				</div>
				<div  class="jksyNrForName">{{item.title}}</div>
				<div  class="jksyNrForCen">{{item.desc}}</div>
			</div>
		</div>
		<div class="jksyDtu">
			<img :src="recruitList.select_ah.cover" v-if="recruitList.select_ah.cover" />
			<img src="@/assets/recruit/datu.png" v-else />
		</div>
	</div>
	<!-- 澳华文化 -->
	<div class="ahwh" v-if="recruitList.ah_culture">
		<div class="ahwhTil">{{recruitList.ah_culture.title}}</div>
		<div class="ahwhCen">{{recruitList.ah_culture.desc}}</div>
		<div class="ahwhForBox">
			<div class="ahwhFor" v-for="(item,index) in recruitList.ah_culture.tableData" :key="index">
				<img :src="item.cover" />
				<div class="ahwhForDw">
					<div class="ahwhForDwName">
						{{item.title}}
					</div>
					<div class="ahwhForDwCen">
						{{item.desc}}
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- 人才培养 -->
	<div class="rcpy" v-if="recruitList.personnel_training">
		<div class="rcpyLeft">
			<div class="rcpyLeftTil">{{recruitList.personnel_training.title}}</div>
			<div class="rcpyLeftCen">
				<div v-for="(item,index) in recruitList.personnel_training.desc" :key="index" :style="{height:item.text?'':'20px',}">{{item.text}}</div>
			</div>
		</div>
		<div class="rcpyRight">
			<img :src="recruitList.personnel_training.cover" v-if="recruitList.personnel_training.cover" />
			<img src="@/assets/recruit/rcpy.png" v-else />
		</div>
	</div>
	<!-- 公司福利 -->
	<div class="gsfl" v-if="recruitList.company_benefits">
		<div class="gsflTil">{{recruitList.company_benefits.title}}</div>
		<div class="gsflBox">
			<div class="gsflBoxFor" v-for="(item,index) in recruitList.company_benefits.tableData" :key="index">
				<div class="gsflBoxForNum">
					{{index<9?'0'+(index+1):(index)}}
				</div>
				<div class="gsflBoxForName">
					{{item.title}}
				</div>
				<div class="gsflBoxForCen">
					<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
				</div>
			</div>
		</div>
	</div>
	<!-- 工作环境 -->
	<div class="gzhj" v-if="recruitList.work_environment">
		<div class="gzhjTil">
			{{recruitList.work_environment.title}}
		</div>
		<div class="gzhjImg">
			<div v-for="(item,index) in recruitList.work_environment.cover" :key="index">
				<img :src="item" />
			</div>
		</div>
	</div>
	<!-- 联系方式 -->
	<div class="lxfs">
		<!-- <div class="lxfsTil">HR联系方式</div> -->
		<div class="lxfsCen">
			{{$t('i18n_322')}}：{{email}}
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		zpList:[
			{
				img:require("@/assets/recruit/shzp.png"),
				name:'社会招聘',
				path:'/recruitSociety'
			},
			{
				img:require("@/assets/recruit/shzp.png"),
				name:'校园招聘',
				path:'/recruitCampus'
			}
		],
		// 健康事业
		jksyList:[
			{
				img:require("@/assets/recruit/qjgk.png"),
				name:'前景广阔',
				cen:'随着人口老龄化、生活方式的改变以及慢性疾病的增加，内镜检查和治疗的需求不断增',
			},
			{
				img:require("@/assets/recruit/zzcx.png"),
				name:'自主创新',
				cen:'身处这个高增长，大前景的行业，我们致力于自主创新，服务临床，尽己所能为患者健康护航。',
			},
			{
				img:require("@/assets/recruit/jksy.png"),
				name:'健康事业',
				cen:'从寻找病灶到探求癌症新解，从健康普查到拯救生命，您的每一点付出与努力都将关乎人类生命健康。',
			},
		],
		ahwhList:[
			{
				img:require("@/assets/recruit/Vision.png"),
				name:'愿景',
				cen:'成为国际领先的内镜整体解决方案提供商'
			},
			{
				img:require("@/assets/recruit/Mission.png"),
				name:'使命',
				cen:'让内镜诊疗变得普及和便捷'
			},
			{
				img:require("@/assets/recruit/Value.png"),
				name:'价值观',
				cen:'专注  创新  持续学习  用户满意  共赢'
			},
		],
		gsflList:[
			{
				name:'满足味蕾',
				cen:'午餐补贴/茶水间免费咖啡'
			},
			{
				name:'丰富实践',
				cen:'团队建设/家庭日年会/大型活动'
			},
			{
				name:'员工关怀',
				cen:'生日祝福/健康体检/节日活动荣誉榜/入职纪念/各类补助'
			},
			{
				name:'员工关怀',
				cen:'生日祝福/健康体检/节日活动荣誉榜/入职纪念/各类补助'
			},
			
			{
				name:'员工关怀',
				cen:'生日祝福/健康体检/节日活动荣誉榜/入职纪念/各类补助'
			},
			{
				name:'员工关怀',
				cen:'生日祝福/健康体检/节日活动荣誉榜/入职纪念/各类补助'
			},
			{
				name:'员工关怀',
				cen:'生日祝福/健康体检/节日活动荣誉榜/入职纪念/各类补助'
			},
			{
				name:'员工关怀',
				cen:'生日祝福/健康体检/节日活动荣誉榜/入职纪念/各类补助'
			},
			{
				name:'员工关怀',
				cen:'生日祝福/健康体检/节日活动荣誉榜/入职纪念/各类补助'
			},
			
		],
		gzhjList:[
			{
				img:require("@/assets/recruit/gzhj.png")
			},
			{
				img:require("@/assets/recruit/gzhj.png")
			},
			{
				img:require("@/assets/recruit/gzhj.png")
			},
			{
				img:require("@/assets/recruit/gzhj.png")
			},
			{
				img:require("@/assets/recruit/gzhj.png")
			},
			{
				img:require("@/assets/recruit/gzhj.png")
			},
		],
		recruitList:{},
		email:'hr@aohua.com'
      }
    },
    mounted() {

    },
    methods: {
		goDetail(item){
			let t=this;
			console.log(item.path)
			if(!item.path){
				return
			}
			console.log(item.path)
			if(t.$route.path != item.path){
				t.$router.push(item.path)
			}
		},
		setList(e){
			console.log(e)
			this.recruitList=e;
		}
    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
	.recruit{
		width: 1200px;
		margin: 0 auto;
	}
.zaopinBox{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-top: 76px;
	.zaopinBoxFor:nth-of-type(1){
		margin-right: 30px;
	}
	.zaopinBoxFor:hover{
		img{
			transform: scale(1.1);
		}
	}
	.zaopinBoxFor{
		cursor: pointer;
		width: 590px;
		border: 2px solid #F3F3F3;
		.zaopinBoxImg{
			overflow: hidden;
			width: 590px;
			height: 300px;
			img{
				width: 590px;
				height: 300px;
				transition: all 0.3s ease-in-out;
			}
		}
		.zaopinBoxBtm{
			display: flex;
			align-items: center;
			padding: 28px 20px;
			cursor: pointer;
			.zaopinBoxBtmName{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #000000;
				flex: 1;
			}
			.zaopinBoxBtmMore{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 300;
				color: #000000;
				margin: 0 20px;
			}
			.zaopinBoxBtmJt{
				display: flex;
				align-items: center;
				width: 8px;
				height: 14px;
			}
		}
		
	}
}
.jksy{
	padding-top: 197px;
	.jksyTil{
		font-size: 36px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
		margin-bottom: 70px;
	}
	.jksyNr{
		display: flex;
		.jksyNrFor:nth-of-type(2n){
			margin: 0 136px;
		}
		.jksyNrFor{
			display: flex;
			align-items: center;
			flex-direction: column;
			justify-content: center;
			.jksyNrForImg{
				img{
					width: 150px;
					height: 150px;
				}
			}
			.jksyNrForName{
				overflow : hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-size: 36px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
				margin: 40px 0;
			}
			.jksyNrForCen{
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #000000;
				height: 100px;
				overflow : hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				// 必须加不然隐藏不了
				/*! autoprefixer: ignore next */
				-webkit-box-orient: vertical;
			}
		}
	}
	.jksyDtu{
		margin-top: 67px;
		img{
			width: 100%;
			object-fit: cover;
		}
	}
}
.ahwh{
	margin-top: 201px;
	.ahwhTil{
		font-size: 36px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
		margin-bottom: 46px;
	}
	.ahwhCen{
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 500;
		color: #000000;
		margin-bottom: 51px;
	}
	.ahwhForBox{
		display: flex;
		justify-content: space-between;
		.ahwhFor{
			width: 390px;
			height: 260px;
			position: relative;
			img{
				object-fit: contain;
				width: 390px;
				height: 260px;
			}
			.ahwhForDw{
				position: absolute;
				top: 0;
				left: 0;
				width: 390px;
				height: 260px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				.ahwhForDwName{
					font-size: 26px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #000000;
					margin-bottom: 20px;
				}
				.ahwhForDwCen{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #000000;
				}
			}
		}
	}
}
.rcpy{
	padding-top: 176px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 204px;
	.rcpyLeft{
		flex: 1;
		width: 0;
		height: 350px;
		display: flex;
		flex-direction: column;
		.rcpyLeftTil{
			font-size: 36px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 41px;
		}
		.rcpyLeftCen{
			flex: 1;
			overflow-y: auto;
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #000000;
			text-align: justify;
			word-wrap: break-word;
			word-break: break-all;
		}
	}
	.rcpyRight{
		margin-left: 106px;
		img{
			object-fit: cover;
			width: 600px;
			height: 350px;
		}
	}
}
.gsfl{
	.gsflTil{
		font-size: 36px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
		margin-bottom: 91px;
	}
	.gsflBox{
		display: flex;
		align-items: center;
		// justify-content: space-between;
		// overflow-x: auto;
		width: 100%;
		flex-wrap: wrap;
		.gsflBoxFor:not(:last-child){
			padding-right: 30px;
		}
		.gsflBoxFor{
			margin-bottom: 30px;
			flex:1;
			text-align: center;
			.gsflBoxForNum{
				font-size: 60px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #EBEBEB;
				margin-bottom: 27px;
			}
			.gsflBoxForName{
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
				margin-bottom: 15px;
			}
			.gsflBoxForCen{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 300;
				color: #000000;
			}
		}
	}
}
.gzhj{
	padding-top: 209px;
	padding-bottom: 209px;
	.gzhjTil{
		font-size: 36px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
		margin-bottom:79px;
	}
	.gzhjImg{
		display: flex;
		width: 100%;
		flex-wrap: wrap;
		>div{
			height: 300px;
			img{
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
		>div:nth-of-type(1){
			width: 25%;
		}
		>div:nth-of-type(2){
			width: 50%;
		}
		>div:nth-of-type(3){
			width: 25%;
		}
		>div:nth-of-type(4){
			width: 50%;
		}
		>div:nth-of-type(5){
			width: 25%;
		}
		>div:nth-of-type(6){
			width: 25%;
		}
	}
	
}
.lxfs{
	padding-bottom: 217px;
	.lxfsTil{
		font-size: 54px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
	}
	.lxfsCen{
		margin-top: 39px;
		// font-size: 30px;
		font-size: 24px;
		font-family: Source Han Sans CN;
		font-weight: 500;
		color: #B3B3B3;
	}
}
</style>
